import Seo from "@/components/site/Seo";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ChatPlaceholder from "@/components/site/ChatPlaceholder";
import { WingDivider } from "@/components/site/Wings";
import { Reveal } from "@/components/site/Reveal";
import { EMAIL, PHONE_DISPLAY, ADDRESS } from "@/lib/contact";

const Section = ({ n, title, children }) => (
  <Reveal as="section" className="mb-10">
    <h2 className="mb-3 flex items-baseline gap-3 font-serif text-xl text-pine md:text-2xl">
      <span className="font-serif text-base text-magenta">{n}</span>
      {title}
    </h2>
    <div className="space-y-3 text-[1rem] leading-relaxed text-soft">{children}</div>
  </Reveal>
);

export default function Privacy() {
  return (
    <div className="relative">
      <Seo
        title="Aviso de Privacidad | CESMA"
        description="Aviso de Privacidad de CESMA — Salud Integral Alas Enlazadas A.C., conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares."
        canonical="https://www.cesma.com.mx/privacy"
        robots="noindex, follow"
      />
      <div className="grain" />
      <Header />

      <main className="mx-auto max-w-3xl px-5 py-16 md:px-8 md:py-24">
        <Reveal>
          <span className="eyebrow">Protección de datos personales</span>
          <h1 className="mt-3 font-serif text-[2.2rem] text-ink sm:text-5xl">Aviso de Privacidad</h1>
        </Reveal>

        <Reveal delay={0.08} className="mt-6 rounded-2xl border border-magenta/25 bg-magenta/5 p-5 text-[0.95rem] text-magentaDeep">
          <b>Aviso vigente.</b> Documento elaborado conforme a la Ley Federal de Protección de
          Datos Personales en Posesión de los Particulares (LFPDPPP). Recomendamos que su área
          legal lo valide y ajuste cualquier dato específico antes de su difusión definitiva.
        </Reveal>

        <WingDivider className="my-12" />

        <Section n="1." title="Identidad y domicilio del responsable">
          <p>
            <b className="text-ink">Salud Integral Alas Enlazadas A.C.</b> (en adelante
            “CESMA”), con domicilio en {ADDRESS}, C.P. 62580, es responsable del
            tratamiento y protección de sus datos personales. Correo de contacto:{" "}
            <a href={`mailto:${EMAIL}`} className="text-pine underline">{EMAIL}</a> · Teléfono:{" "}
            {PHONE_DISPLAY}.
          </p>
        </Section>

        <Section n="2." title="Datos personales que recabamos">
          <p>
            Podemos recabar datos de identificación y contacto (nombre, teléfono, correo
            electrónico) y, en su caso, datos del familiar o paciente.
          </p>
          <p>
            <b className="text-ink">Datos personales sensibles.</b> Dada la naturaleza de
            nuestros servicios de salud, podremos tratar datos sensibles (estado de salud
            físico y mental, antecedentes clínicos). Su tratamiento requiere su{" "}
            <b className="text-ink">consentimiento expreso</b>, conforme a los artículos 8, 9 y
            demás aplicables de la LFPDPPP.
          </p>
        </Section>

        <Section n="3." title="Finalidades del tratamiento">
          <p><b className="text-ink">Primarias:</b> brindar orientación, valoración y atención clínica; agendar citas; dar seguimiento al tratamiento; y contactarle por los medios proporcionados.</p>
          <p><b className="text-ink">Secundarias:</b> envío de información institucional, recordatorios de cita y encuestas de calidad. Usted puede oponerse a estas finalidades secundarias sin que ello afecte la prestación del servicio.</p>
        </Section>

        <Section n="4." title="Transferencias de datos">
          <p>
            No transferiremos sus datos a terceros salvo las excepciones previstas en el
            artículo 37 de la LFPDPPP o cuando sea necesario para su atención médica. En caso
            de requerir cualquier otra transferencia, solicitaremos su consentimiento cuando la
            ley así lo exija.
          </p>
        </Section>

        <Section n="5." title="Medios para ejercer los derechos ARCO">
          <p>
            Usted tiene derecho a Acceder, Rectificar, Cancelar u Oponerse al tratamiento de
            sus datos (derechos ARCO), así como a revocar su consentimiento. Para ello, envíe
            su solicitud a{" "}
            <a href={`mailto:${EMAIL}`} className="text-pine underline">{EMAIL}</a>, indicando
            nombre, medio para recibir respuesta y la descripción de su solicitud. Daremos
            respuesta en un plazo máximo de 20 días hábiles y, de resultar procedente, la
            haremos efectiva dentro de los 15 días hábiles siguientes.
          </p>
        </Section>

        <Section n="6." title="Limitación de uso o divulgación">
          <p>
            Puede solicitar la limitación del uso o divulgación de sus datos personales al
            correo señalado. Mantenemos medidas de seguridad administrativas, técnicas y
            físicas para proteger su información.
          </p>
        </Section>

        <Section n="7." title="Uso de cookies y tecnologías de rastreo">
          <p>
            Este sitio utiliza cookies y tecnologías de análisis de tráfico (métricas de uso
            del sitio) y muestra un mapa de ubicación embebido de Google Maps. Puede
            deshabilitar las cookies desde la configuración de su navegador.
          </p>
        </Section>

        <Section n="8." title="Cambios al aviso de privacidad">
          <p>
            Cualquier modificación a este aviso será publicada en{" "}
            <span className="text-pine">www.cesma.com.mx/privacy</span>. Última actualización:
            junio de 2026.
          </p>
        </Section>
      </main>

      <Footer />
      <ChatPlaceholder />
    </div>
  );
}
